import { UsageFeatureProps } from '@employee-experience/common';
import { ILetterTemplate } from '../../models/ILetterTemplate';

export enum TemplateActionTypes {
  REQUEST_TEMPLATES = 'REQUEST_TEMPLATES',
  RECEIVE_TEMPLATES = 'RECEIVE_TEMPLATES',
  REQUEST_TEMPLATES_FAILED = 'REQUEST_TEMPLATES_FAILED',
}

export interface IRequestTemplatesAction {
  type: TemplateActionTypes.REQUEST_TEMPLATES;
  feature: UsageFeatureProps;
  impersonatedCompanyCode: string;
  impersonatedCostCenter: string;
}

export interface IReceiveTemplatesAction {
  type: TemplateActionTypes.RECEIVE_TEMPLATES;
  templates: ILetterTemplate[];
}

export interface IReceiveTemplatesFailedAction {
  type: TemplateActionTypes.REQUEST_TEMPLATES_FAILED;
  errorMessage: string;
  statusCode: number;
}

export type TemplateActions =
  | IRequestTemplatesAction
  | IReceiveTemplatesAction
  | IReceiveTemplatesFailedAction;
